// ✏️  Edita los textos entre comillas
// ➕  Para agregar una opción, copia un bloque { } y pégalo
// ⚠️  No elimines llaves { }, corchetes [ ] ni comas ,

export const CUENTAS_COBRAR = {
  mensaje: '¿Qué necesitas en Cuentas por Cobrar?',
  opciones: [
    {
      boton: 'Registrar un cobro',
      respuesta: 'Ve a C. por Cobrar → Cobros. Selecciona el cliente y los documentos pendientes que deseas cancelar.',
    },
    {
      boton: 'Estado de cuenta de un cliente',
      respuesta: 'El estado de cuenta está en C. por Cobrar → Consultas → Estado de cuenta. Filtra por cliente y rango de fechas.',
    },
    {
      boton: 'Documentos vencidos',
      respuesta: 'Consulta los documentos vencidos en C. por Cobrar → Consultas → Cartera vencida.',
    },
  ],
}
